import React from 'react'
import AddQuantityOfferForm from '../../modules/QuantityOffer/components/AddQuantityOfferForm'
export default function AddQuantityOfferPage() {
  return <AddQuantityOfferForm />
}
